module.exports = __webpack_public_path__ + "static/image4-7a1b2fe3e4d44ea30fbab624d9ddb9b8.jpg";